import { FC } from 'react';
import { Box, IconButton, useTheme } from '@material-ui/core';
import ListIcon from '@material-ui/icons/List';
import ViewModuleIcon from '@material-ui/icons/ViewModule';
import { useScaffolderPageContext } from './context/useScaffolderPageContext';

export const ScaffolderViewTypeButtons: FC = () => {
  const { setViewType, viewType } = useScaffolderPageContext();

  const theme = useTheme();

  return (
    <Box
      style={{
        display: 'flex',
        marginLeft: theme.spacing(2),
        alignItems: 'baseline',
        paddingTop: theme.spacing(1),
      }}
    >
      <div
        style={{
          width: '1px',
          height: '24px',
          marginRight: theme.spacing(1),
          background: theme.palette.grey[300],
        }}
      />

      <IconButton
        onClick={() => {
          setViewType('grid');
        }}
        color={viewType === 'grid' ? 'primary' : 'secondary'}
        size="small"
        aria-label="set view to grid"
      >
        <ViewModuleIcon />
      </IconButton>
      <IconButton
        onClick={() => {
          setViewType('table');
        }}
        color={viewType === 'table' ? 'primary' : 'secondary'}
        size="small"
        aria-label="set view to table"
      >
        <ListIcon />
      </IconButton>
    </Box>
  );
};
